import { FaLightbulb } from "react-icons/fa";
import { FiMic } from "react-icons/fi";
import { GiStethoscope } from "react-icons/gi";
import { MdPower } from "react-icons/md";
import Theme from "./Theme";

// Sample feature images, replace with actual paths
// const FEATURE_IMAGES = {
//   documentation:
//     "https://res.cloudinary.com/dqchrdrin/image/upload/v1735743736/transcriptions_eke8k5.gif",
//   transcription: "/assets/features/transcription.gif",
//   coding:
//     "https://res.cloudinary.com/dqchrdrin/image/upload/v1735730048/medical-codes_k1vdrb.gif",
//   clinical: "/assets/features/clinical.gif",
// };

// interface HomePageFeature {
//   title: string;
//   description: string;
//   image: string;
//   icon: React.JSX.Element;
// }

export const HOME_PAGE_FEATURES = [
  {
    title: "Real-time transcription & translation",
    icon: <FiMic size={Theme.SIZES.ICON_LARGE} />,
    image:
      "https://res.cloudinary.com/dqchrdrin/image/upload/v1735743736/transcriptions_eke8k5.gif",
    description:
      "Experience instant, multilingual transcription and translation capabilities. From consultations to global collaborations, our system ensures accurate communication across languages in real-time.",
  },
  {
    title: "FHIR HL7 compliant interoperability",
    icon: <MdPower size={Theme.SIZES.ICON_LARGE} />,
    image:
      "https://res.cloudinary.com/dqchrdrin/image/upload/v1735730021/interop_czowjq.gif",
    description:
      "Seamlessly integrate with healthcare systems using full adherence to FHIR HL7 standards. Our solution ensures compatibility across electronic health records (EHRs), enabling secure and efficient data exchange for better patient outcomes.",
  },
  {
    title: "Actionable medical insights",
    icon: <FaLightbulb size={Theme.SIZES.ICON_LARGE} />,
    image:
      "https://res.cloudinary.com/dqchrdrin/image/upload/v1735743734/medical-insights_h3eyyl.gif",
    description:
      "Transform complex conversations into valuable insights. Our solution identifies key takeaways, such as symptoms, diagnoses, and treatments, empowering healthcare professionals to make informed decisions quickly.",
  },
  {
    title: "Automatic medical coding",
    icon: <GiStethoscope size={Theme.SIZES.ICON_LARGE} />,
    image:
      "https://res.cloudinary.com/dqchrdrin/image/upload/v1735730048/medical-codes_k1vdrb.gif",
    description:
      "Simplify billing and administrative tasks with precise CPT and HCPCS code extraction. Streamline documentation processes and improve accuracy in claims submissions with our AI-powered coding engine.",
  },
];

interface PodcastEpisode {
  title: string;
  url: string;
}

export const PODCAST_EPISODES: PodcastEpisode[] = [
  {
    title: "The Future of AI in Healthcare Documentation",
    url: "https://open.spotify.com/episode/547COlUUMMVDx0Akgdnfkm",
  },
  {
    title: "Empathy in Healthcare: Reimagining Doctor-Patient Engagement",
    url: "https://open.spotify.com/episode/547COlUUMMVDx0Akgdnfkm?si=1ee5dc683a7046f6",
  },
  {
    title: "Tech Deep Dive: QiQ and the Future of Healthcare",
    url: "https://open.spotify.com/episode/48wr0JBm8rXR3XP5XrBWKN?si=8da53e6f594a467c",
  },
];

export const WORKFLOW_IMAGE =
  "https://res.cloudinary.com/dqchrdrin/image/upload/v1735743732/workflow_tf9lgu.gif";
